import { atomFamily } from 'jotai-family';
import { atomWithQuery } from 'jotai-tanstack-query';

import { fetchConsultationTranscriptExists } from '../api/fetchConsultationTranscriptExists';

const CONSULTATION_TRANSCRIPT_EXISTS_QUERY_KEY =
    'CONSULTATION_TRANSCRIPT_EXISTS';

export const consultationTranscriptExistsAtom = atomFamily(
    (consultationUid: string) =>
        atomWithQuery(() => ({
            queryKey: [
                CONSULTATION_TRANSCRIPT_EXISTS_QUERY_KEY,
                consultationUid,
            ],
            queryFn: () => fetchConsultationTranscriptExists(consultationUid),
        })),
);
